import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root',
})
export class EncryptDecrypt {
    encryptSecretKey = environment.secretKey;
    encryptData(data) {
        try {
            return CryptoJS.AES.encrypt(
                JSON.stringify(data),
                this.encryptSecretKey
            ).toString();
        } catch (e) { }
    }

    //  decryptData(encryptedData) {
    //     try {
    //         console.log(encryptedData);

    //       // Decrypt the encrypted data
    //       const bytes = CryptoJS.AES.decrypt(encryptedData, this.encryptSecretKey);
    //       const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    //       let val =JSON.parse(decryptedString);
    //       // Parse the decrypted JSON string back to an object
    //       return val;
    //     } catch (e) {
    //       console.error("Decryption failed:", e);
    //       return null;
    //     }
    //   }

    decryptData(encryptedData) {
        try {
            // Decrypt the encrypted data  
            let encryptedBase64 = CryptoJS.enc.Hex.parse(encryptedData).toString(CryptoJS.enc.Base64);
            let decryptedData = CryptoJS.AES.decrypt(encryptedBase64, this.encryptSecretKey).toString(CryptoJS.enc.Utf8);
            // Parse the decrypted JSON string back to an object  
            const planDetail = JSON.parse(decryptedData);            
            return planDetail;
        } catch (e) {
            return null;
        }
    }
}    